<template>
    <SoliDate
        type="month"
        noTitle
        label="Compare Month"
        clearable
        hide-details
        :max="max"
        :value="value ? globalMomentUTCMonthYear(new Date(value)) : null"
        :rules="[]"
        :disabled="disabled"
        @input="
            $emit('input', {
                compareMonth: $event,
                compareYear: null,
            })
        "
        @clear="
            $emit('clear', {
                compareMonth: null,
                compareYear: null,
            })
        "
    />
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
        date: {
            type: String,
            default: null,
        },
    },
    mixins: [globalMoment],
    computed: {
        max() {
            return this.globalMomentISO(
                moment(new Date(this.date)).tz("UTC").subtract(1, "month")
            );
        },
    },
};
</script>
